<template>
    <wizard-layout :id="this.step">
        <template>
            <wizard-box-left>

                <div class="row">
                    <div class="col-md-7 col-12 mb-3 mt-4">
                        <h3> Ci dispiace ma il servizio non è ancora attivo nella tua zona. </h3>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-7 col-12 mb-6">
                        <h1 class="font-weight-bolder colored-label">Puoi comunque richiedere una valutazione, anche se non potrai ricevere un’offerta di acquisto del tuo immobile.</h1>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6 col-12 mb-3">
                        <label>Il servizio sarà presto disponibile anche in altre città.
                            Lascia i tuoi contatti per restare aggiornato.</label>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 col-12 d-lg-flex d-md-flex text-left mb-2 d-block-sm">
                        <div class="col-md-4 col-12 pl-0 name-input">
                            <input type="text" name="name" v-model="name" class="form-control" placeholder="Nome"/>
                        </div>
                        <div class="col-md-4 col-12 email-input">
                            <input type="email" name="email" v-model="email" class="form-control" placeholder="Email"/>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 d-flex align-items-center mb-4">
                        <input class="form-control mr-2" type="checkbox" v-model="privacy" name="privacy" required />
                        <label class="font-weight-normal">Ho letto e accetto l'informativa sulla <a href="javascript"> privacy </a> </label>
                    </div>
                </div>

                <div class="row">
                    <div class="col-3">
                        <button type="button" class="btn btn-primary text-nowrap" @click="sendEmail($event)" :disabled="isEmailDisabled">Tienimi aggiornato</button>
                    </div>
                </div>

            <wizard-footer :step="'alt'"></wizard-footer>
            </wizard-box-left>
            <wizard-box-right :id="this.step">
                <div class="wizard-map">
                    <GmapMap
                        :center="getPosition()"
                        :zoom="19"
                        style="width: 100%; height: 100%; border: 0;"
                    >
                        <GmapMarker
                            :position="getPosition()"
                            :clickable="true"
                            :draggable="true"
                            @click="center=getPosition()"
                        />
                    </GmapMap>
                </div>
            </wizard-box-right>
        </template>
    </wizard-layout>
</template>


<script>
import WizardLayout from "@/Pages/Wizard/Layouts/WizardLayout";
import WizardBoxRight from "@/Pages/Wizard/Layouts/WizardBoxRight";
import WizardBoxLeft from "@/Pages/Wizard/Layouts/WizardBoxLeft";
import WizardStep from "@/Pages/Wizard/Elements/WizardStep";
import WizardFooter from "@/Pages/Wizard/Elements/WizardFooter";
import {redirectWizardSteps} from "@/helpers/helper";

export default {
    props: ['data','user'],

    components: {WizardFooter, WizardStep, WizardBoxLeft, WizardLayout, WizardBoxRight},

    computed: {
        isEmailDisabled() {
            return !this.fieldsAreEmpty()
        }
    },

    data() {
        return {
            step: 'alt',
            name: '',
            email: '',
            privacy: false,
            lat: '',
            lng: ''
        }
    },

    methods: {
        isAgency() {
            return (this.user !== null && !(window.location.href.includes('customer')))
        },

        getPosition() {
            return {
                lat: parseFloat(this.lat),
                lng: parseFloat(this.lng)
            }
        },

        sendEmail(e) {
            axios.post('keep-updated',{
                email: this.email,
                name: this.name
            }).then(response => {
                if (response.data.type === 'error') {
                    this.$toast.error(response.data.message)
                } else {
                    this.$toast.success(response.data.message)
                }

                this.email = ''
                this.name = ''
                this.privacy = false
            }).catch(error => {
                console.log(error)
            })
        },

        handleRequest(address) {
            let url = process.env.MIX_APP_GOOGLE_MAPS_ENDPOINT + '?address=' + address + '&key=' + process.env.MIX_APP_GOOGLE_MAPS_API_KEY
            axios.get(url)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.results.length > 0) {
                            let geometry = response.data.results[0].geometry

                            this.lat = geometry.location.lat
                            this.lng = geometry.location.lng
                        } else {
                            this.$toast.error('Address is not correct')
                        }
                    } else {
                        this.$toast.error('Address is not correct')
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },

        fieldsAreEmpty() {
            return (this.email !== '' && this.name !== '' && this.privacy === true)
        }
    },

    beforeMount() {
        redirectWizardSteps(this.isAgency(),this.step,'test',this.$inertia)

        axios.get('/wizard/properties/' + localStorage.getItem('current_property_id'))
             .then(response => {
                 let address = response.data.house_number + '+' + response.data.address +
                     '+' + response.data.municipality + '+' + response.data.postal_code +
                     '+' + response.data.country

                 this.handleRequest(address)
             })
             .catch(error => {
                 console.log(error)
             })
    }
}
</script>
